import { render, staticRenderFns } from "./advertising-edit-old.vue?vue&type=template&id=093cd5c8&scoped=true"
import script from "./advertising-edit-old.vue?vue&type=script&lang=js"
export * from "./advertising-edit-old.vue?vue&type=script&lang=js"
import style0 from "./advertising-edit-old.vue?vue&type=style&index=0&id=093cd5c8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093cd5c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('093cd5c8')) {
      api.createRecord('093cd5c8', component.options)
    } else {
      api.reload('093cd5c8', component.options)
    }
    module.hot.accept("./advertising-edit-old.vue?vue&type=template&id=093cd5c8&scoped=true", function () {
      api.rerender('093cd5c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/advertising/components/advertising-edit-old.vue"
export default component.exports